
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'StylePicker',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      styles: [],
    }
  },
  computed: {
    ...mapGetters({
      generalSettings: 'storyblok/settings',
      getCentraProduct: 'centra-product/getProductById',
      getGbFeatureValue: 'growthbook/getGbFeatureValue',
    }),
    comfortSuiteStylePickerEnabled () {
      return this.getGbFeatureValue('comfort-suite:style-picker', false)
    },
  },
  async mounted () {
    this.styles = await this.getStyleProducts()
  },
  methods: {
    ...mapActions({
      lookupProduct: 'centra-product/lookupProducts',
    }),
    async getProduct (id) {
      try {
        let product = this.getCentraProduct(id)
        if (!product) {
          await this.lookupProduct(id)
          product = this.getCentraProduct(id)
        }
        return product
      } catch (error) {
        console.error(`Failed to fetch product with ID: ${id}`, error)
        return null
      }
    },
    async getStyleProducts () {
      const stylePickerItems = this.generalSettings?.style_picker?.[0]?.items || []
      if (!stylePickerItems.length) { return [] }

      const styles = []
      for (const style of stylePickerItems) {
        const product = await this.getProduct(style.product_id)
        if (product) {
          styles.push({
            hasBackClosure: product.hasBackClosure,
            wiring: product.wiring,
            productUrl: product.url,
            image: style.image,
            label: style.label,
            sku: product.sku,
            isWired: product.isWired,
            name: product.name,
            hasLace: product.hasLace,
            hasSideWing: product.hasSideWing,
            url: product.url,
            feature: style.tracking_key
          })
        }
      }
      return styles
    },
    isActiveStyle (style) {
      if (!style.hasBackClosure && !this.product?.hasBackClosure && style.feature === 'hasBackClosure') {
        return true
      }
      if (style.hasBackClosure && this.product?.hasBackClosure && style.feature === 'isWired') {
        return style.isWired === this.product?.isWired
      }
      if (style.hasBackClosure && this.product?.hasBackClosure && style.feature === 'hasSideWing') {
        return style.hasSideWing === this.product?.hasSideWing
      }
      return false
    },
    getProductTrackingData (product, key, toggleValues) {
      return {
        name: product?.name,
        sku: product?.sku,
        url: product?.url,
        toggleValue: product[key] ? toggleValues?.[0] : toggleValues?.[1]
      }
    },
    getUniqueStylePickerFeatures (features) {
      const uniqueKeys = new Set()
      return features.filter((feature) => {
        if (uniqueKeys.has(feature.tracking_key)) {
          return false
        } else {
          uniqueKeys.add(feature.tracking_key)
          return true
        }
      })
    },
    trackData (source, target) {
      const data = []
      let stylePickerFeatures = this.generalSettings?.style_picker?.[0]?.items || []
      /**
       * since there is only one product property eg isWired but one toggle for non-wired and one for wired
       * we want to filter so we only track the unique features
      */
      stylePickerFeatures = this.getUniqueStylePickerFeatures(stylePickerFeatures)
      if (stylePickerFeatures?.length === 0) { return data }

      for (const feature of stylePickerFeatures) {
        if (source?.[feature.tracking_key] !== target?.[feature.tracking_key]) {
          const toggleValues = feature?.toggle_values?.split(',')
          const sourceProduct = this.getProductTrackingData(source, feature.tracking_key, toggleValues)
          const targetProduct = this.getProductTrackingData(target, feature.tracking_key, toggleValues)
          data.push({
            source_product: sourceProduct,
            target_product: targetProduct
          })
        }
      }

      return data || {}
    },
    handleSubmit (url, style) {
      if (this.product?.url === url) { return }
      const features = this.trackData(this.product, style)
      for (const feature of features) {
        this.gtm_trackComfortSuiteClickEvent('comfort_suite_click', feature, 'StylePicker')
      }
      this.$router.push(url)
    },
  }
}
